import React, { useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import qs from "qs";
import { styled } from "@mui/material/styles";
import { useLocation } from "react-router-dom";

import { withState } from "../../../services/state";
import { completeDurectDebitSetup as apiCompleteDurectDebitSetup } from "../../../services/api";

import PageWrapper from "../../components/pageWrapper/PageWrapper";
import AuthenticationFlow from "../../components/authenticationFlow/AuthenticationFlow";

const ReturnToAccount = styled("div")(({ theme }) => ({
  marginTop: "20px",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

const ReturnToApp = styled("div")(({ theme }) => ({
  marginTop: "20px",
  display: "none",
  [theme.breakpoints.down("sm")]: {
    display: "block",
  },
}));

const CompleteMandateSetupPage = ({ classes }) => {
  const location = useLocation();

  const completeMandateSetup = useCallback(async () => {
    console.log(location);
    const queryParams = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });

    try {
      await apiCompleteDurectDebitSetup(queryParams.redirect_flow_id);
    } catch (e) {
      console.log(e);
    }
  }, [location]);

  useEffect(() => {
    completeMandateSetup();
  }, [completeMandateSetup]);

  return (
    <PageWrapper showHeader={true}>
      <AuthenticationFlow
        currentStep={0}
        steps={[
          <div>
            <div style={{ marginBottom: 20 }}>Complete!</div>
            <div>
              Thank you for setting up your Gocardless account, you can now pay
              for events.
            </div>
            <ReturnToAccount>
              <Link to="/">Return to your account</Link>
            </ReturnToAccount>
            <ReturnToApp>
              Return to the app to start paying for events
            </ReturnToApp>
          </div>,
        ]}
      />
    </PageWrapper>
  );
};

export default withState(CompleteMandateSetupPage);
